import { useEffect, useState } from "react";
import axiosInstance from "../util/AxiosInstance/AxiosInstance";

export const useBlogPosts = () => {
    const [posts, setPosts] = useState([]);
    const [loading, setLoading] = useState(true);
    const [message, setMessage] = useState('');
    const [error, setError] = useState(false);

    const fetchPosts = async () => {
        setLoading(true);
        setError(false);

        try {
            const response = await axiosInstance.get('/admin/public/getAllBlogPosts');

            if (!response.data.success) {
                // console.log("Error fetching all blog posts:", response.data.message);
                setMessage(response.data.message || 'Error fetching all posts');
                setError(true);
                return;
            }

            setPosts(response.data.posts || []);
            setMessage(response.data.message);
        } catch (err) {
            // console.log("Error fetching all blog posts:", err);
            setError(true);
            setMessage('Error fetching all blog posts');
        } finally {
            setLoading(false);
        }
    };

    useEffect(() => {
        fetchPosts();
    }, []);

    return { posts, loading, message, error, refetch: fetchPosts };
};


